import { styled } from "@mui/material/styles";

// Components
import { Typography } from "@mui/material";
import { theme } from "~/components/Common";

const styledName = "DayTransactions";

export const StyledWrapper = styled("div", { name: styledName })({
  "&": {
    maxWidth: "500px",
    minWidth: "400px",
    padding: "10px 20px",
  },
});

export const StyledDayWrapper = styled("div", { name: styledName })({
  "&": {
    borderBottom: `solid 1px ${theme.palette.grey[700]}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "-10px -20px 0 -20px",
  },
});

export const StyledDayTotal = styled(Typography, { name: styledName })({
  "&": {
    color: theme.palette.info.main,
    fontSize: "1.8rem",
  },
});

export const StyledDate = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "2.4rem",
    margin: "0 10px",
  },
});

export const StyledFullDate = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
});

export const StyledWeekDate = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    flexDirection: "column",
    whiteSpace: "nowrap",
  },
});
